import {CameraView} from 'expo-camera';
import React, {LegacyRef, useRef} from 'react';
import {useWindowDimensions, View} from 'react-native';

import {useAppSelector} from '../../store/hooks';
import {CameraControls} from './components/controls';

export function CameraScreen() {
  const cameraRef = useRef<CameraView>();
  const facing = useAppSelector(state => state.camera.cameraFacing);

  const {height, width} = useWindowDimensions();

  return (
    <View
      style={{
        backgroundColor: 'transparent',
        position: 'relative',
        width,
        height: height - 100,
        zIndex: 1,
      }}>
      <CameraView
        ref={cameraRef as LegacyRef<CameraView>}
        facing={facing}
        style={{
          width,
          height: '100%',
          top: 0,
          position: 'absolute',
          zIndex: 10,
        }}>
        <CameraControls camera={cameraRef} />
      </CameraView>
    </View>
  );
}
